import React, { Fragment, useState } from "react";
import {
  Button,
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
} from "@lemonadetraining/web-ui";
import {
  IconEdit,
  IconTrash,
  IconList,
  IconDeviceFloppy,
  IconX,
  IconCopy,
} from "@tabler/icons-react";
import ViewAthletesScoresWidget from "./ViewAthletesScoresWidget";
import MyModal from "@lemonadetraining/web-shared/components/MyModal";

const WorkoutRecodsTOOLTIP = "View athletes comments and recorded scores on current page";

const WorkoutAdditionalAction = (props) => {
  const [showRecords, setShowRecords] = useState(false);

  const onCopyCard = () => {
    if (props.onCopyClicked) {
      props.onCopyClicked();
    }
  };

  const onEditCard = () => {
    if (props.onEditClicked) {
      props.onEditClicked();
    }
  };

  const onSavedCard = () => {
    if (props.onSavedClicked) {
      props.onSavedClicked();
    }
  };

  const onCancelEdit = () => {
    if (props.onCancelEditClicked) {
      props.onCancelEditClicked();
    }
  };

  const onDeleteCard = () => {
    if (props.onDeleteClicked) {
      props.onDeleteClicked();
    }
  };

  return (
    <div className="flex flex-row">
      <TooltipProvider>
        {props.workoutUID && (
          <div className="flex flex-row items-center">
            <Tooltip>
              <TooltipTrigger asChild>
                <Button
                  variant="ghost"
                  size="icon"
                  className="size-8"
                  aria-label="Workout Portal"
                  onClick={() => {
                    setShowRecords(true);
                  }}
                >
                  <IconList className="size-4" />
                </Button>
              </TooltipTrigger>
              <TooltipContent>{WorkoutRecodsTOOLTIP}</TooltipContent>
            </Tooltip>
          </div>
        )}
        {props.isMyWorkout && (
          <div className="flex flex-row items-center">
            <Tooltip>
              <TooltipTrigger asChild>
                <Button variant="ghost" size="icon" className="size-8" onClick={onCopyCard}>
                  <IconCopy className="size-4" />
                </Button>
              </TooltipTrigger>
              <TooltipContent>Copy</TooltipContent>
            </Tooltip>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button variant="ghost" size="icon" className="size-8" onClick={onEditCard}>
                  <IconEdit className="size-4" />
                </Button>
              </TooltipTrigger>
              <TooltipContent>Edit</TooltipContent>
            </Tooltip>
          </div>
        )}
        {props.workoutUID && props.isMyWorkout && (
          <div className="flex flex-row items-center">
            <Tooltip>
              <TooltipTrigger asChild>
                <Button variant="ghost" size="icon" className="size-8" onClick={onDeleteCard}>
                  <IconTrash className="size-4" />
                </Button>
              </TooltipTrigger>
              <TooltipContent>Delete</TooltipContent>
            </Tooltip>
          </div>
        )}
        <div className="flex-auto" />
        {props.isMyWorkout && (
          <div className="flex flex-row items-center">
            <Tooltip>
              <TooltipTrigger asChild>
                <Button
                  variant="ghost"
                  size="icon"
                  className="size-8"
                  onClick={onSavedCard}
                  disabled={!props.editMode}
                >
                  <IconDeviceFloppy className="size-4" />
                </Button>
              </TooltipTrigger>
              <TooltipContent>Save</TooltipContent>
            </Tooltip>
            <Tooltip>
              <TooltipTrigger asChild>
                <Button
                  variant="ghost"
                  size="icon"
                  className="size-8"
                  onClick={onCancelEdit}
                  disabled={!props.editMode}
                >
                  <IconX className="size-4" />
                </Button>
              </TooltipTrigger>
              <TooltipContent>Cancel Edit</TooltipContent>
            </Tooltip>
          </div>
        )}
      </TooltipProvider>
      <Fragment>
        {showRecords && (
          <MyModal
            open={showRecords}
            onClose={() => setShowRecords(false)}
            title="Athletes Scores"
            showTitle={false}
          >
            <ViewAthletesScoresWidget workoutCardUID={props.workoutUID} />
          </MyModal>
        )}
      </Fragment>
    </div>
  );
};

export default WorkoutAdditionalAction;
